export enum FlexAlignItemsOption {
    FlexStart = 'flex-start',
    Center = 'center',
    FlexEnd = 'flex-end',
    Stretch = 'stretch',
    Baseline = 'baseline'
}
